export default "__VITE_ASSET__B5TlqEK7__"